import Link from 'next/link';

import { useMediaQuery, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  imageWrapper: {
    borderRadius: theme.spacing(2),
    '& > div': {
      display: 'block !important',
    },
  },
  boxShadow: {
    boxShadow: '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
  },
  image: {
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

export default function Hero(props) {
  const {
    className,
    section,
    title,
    subtitle,
    label,
    image,
    cta,
    href,
    customStyle,
    refElem,
    onLearnMore,
    ...rest
  } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  const { url: imgSrc, alt: imgAlt } = image || {};

  return (
    <SectionDynamic type={section} className={classes.pagePaddingTop}>
      <div className={className} ref={refElem} {...rest}>
        <Grid
          container
          justifyContent="space-between"
          spacing={4}
          direction={isMd ? 'row' : 'column-reverse'}>
          <Grid item container alignItems="center" xs={12} md={6} data-aos="fade-up">
            <SectionHeader
              title={title || ''}
              subtitle={subtitle}
              label={label}
              ctaGroup={[
                <Link
                  href={href || '/schedule?utm_campaign=platform-details&utm_content=hero'}
                  passHref
                  key="scheduleCta">
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    component="a"
                    aria-label={cta || 'Agendar demonstração'}>
                    {cta || 'Agendar demonstração'}
                  </Button>
                </Link>,
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  onClick={onLearnMore}
                  aria-label="Saiba mais"
                  key="learnMoreCta">
                  Saiba mais
                </Button>,
              ]}
              align="left"
              disableGutter
              titleVariant="h3"
            />
          </Grid>
          <Grid
            item
            container
            justify="flex-start"
            alignItems="center"
            xs={12}
            md={6}
            data-aos="fade-up">
            {imgSrc && (
              <div className={clsx(classes.imageWrapper, classes[customStyle])}>
                <Image
                  src={imgSrc}
                  alt={imgAlt || 'Eskolare'}
                  width="100%"
                  className={classes.image}
                />
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </SectionDynamic>
  );
}

Hero.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  label: PropTypes.string,
  image: PropTypes.object,
  cta: PropTypes.string,
  href: PropTypes.string,
  customStyle: PropTypes.string,
  refElem: PropTypes.any,
  onLearnMore: PropTypes.func,
};
